<h1></h1>
<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                    <!-- Sidebar maximize and minimize arrow buttons -->
                    <div class="sticky-top">
                        <small class="bg-white">
                            <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                                <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                            </a>
                        </small>
                    </div>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <!-- Pagination numbers -->
                <pagination
                    (pageChanged)="search($event)"
                    class="pagination-sm"
                    [boundaryLinks]="true"
                    [totalItems]="count"
                    [maxSize]="5"
                    [itemsPerPage]="searchParams.per_page"
                    [(ngModel)]="searchParams.page"
                    previousText="&lsaquo;"
                    nextText="&rsaquo;"
                    firstText="&laquo;"
                    lastText="&raquo;">
                </pagination>
            </div>
            <div class="text-center pt-1">
                <!-- Pagination count -->
                <app-pagination-count
                    [count]="count"
                    singularName="Activity Matter Rate"
                    pluralName="Activity Matter Rates">
                </app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                    <div class="pull-right float-right">
                        <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                    </div>
                    <span>
                        Search&nbsp;&nbsp;
                        <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
                    </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="rate-type">Rate type:</label>
                            <select class="form-control" id="rate-type" [(ngModel)]="searchParams.rate_type_id" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]="rateType.value" *ngFor="let rateType of searchOptions.rate_types">{{rateType.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="activity">Activities:</label>
                            <select class="form-control" id="activity" [(ngModel)]="searchParams.activity_id" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]="activity.value" *ngFor="let activity of searchOptions.activities">{{activity.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="matter-type">Matter type:</label>
                            <select class="form-control" id="matter-type" [(ngModel)]="searchParams.matter_type_id" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]="matterType.value" *ngFor="let matterType of searchOptions.matter_types">{{matterType.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="per-page">Per Page:</label>
                            <input class="form-control" type="number" id="per-page" name="per-page" [(ngModel)]="searchParams.per_page" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-checkbox" (click)="searchParams['rate_only'] = !searchParams['rate_only']">
                                <input type="checkbox" class="custom-control-input" [checked]="searchParams['rate_only']" [(ngModel)]="searchParams['rate_only']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
                                <label class="custom-control-label">Only those with a rate</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-checkbox" (click)="searchParams['is_global'] = !searchParams['is_global']">
                                <input type="checkbox" class="custom-control-input" [checked]="searchParams['is_global']" [(ngModel)]="searchParams['is_global']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
                                <label class="custom-control-label">Only those that are global</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-checkbox" (click)="searchParams['csv'] = !searchParams['csv']">
                                <input type="checkbox" class="custom-control-input" [checked]="searchParams['csv']" [(ngModel)]="searchParams['csv']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
                                <label class="custom-control-label">Export as CSV file</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <a class="btn btn-primary btn-sm" style="width: 100%" type="button" target='_blank'
                            [href]="'/' + downloadCsvUrl" [ngClass]="{'disabled-link': !searchParams['csv']}">
                                Download CSV
                            </a>
                        </div>
                        <div class="form-group">
                            <app-search-btn [searching]="searching" (onClick)="searchParams.page = 1; search(null, true)"></app-search-btn>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px;">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Activity Matter Rates</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table table-striped" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Activity</th>
                                <th>Matter Type</th>
                                <th>Rate Type</th>
                                <th>Rate</th>
                                <th>Global ?</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let activityMatterRate of activityMatterRates">
                                <td><a [routerLink]="['/activity_matter_rates/', activityMatterRate.id]">{{activityMatterRate.id}}</a></td>
                                <td>{{activityMatterRate.activity.name}}</td>
                                <td>{{activityMatterRate.matter_type ? activityMatterRate.matter_type.name : "No Matter Type" }}</td>
                                <td>{{activityMatterRate.rate_type.name}}</td>
                                <td>{{activityMatterRate.rate}}</td>
                                <td>{{activityMatterRate.is_global}}</td>
                                <td>
                                    <button class="btn btn-link" (click)="delete(activityMatterRate.id)">Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
